import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ImportChatsComponent } from './import-chats.component';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  { path: '', component: ImportChatsComponent, data: { title: 'Import Chats' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ImportChatsRoutingModule { }
